var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageFavorite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/message-favorite"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-favorite"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H12",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.1997 4.62008C14.8697 3.63008 15.2597 2.41008 16.3397 2.07008C16.8997 1.90008 17.5997 2.04008 17.9997 2.57008C18.3797 2.02008 19.0997 1.90008 19.6597 2.07008C20.7397 2.40008 21.1297 3.63008 20.7997 4.62008C20.2897 6.19008 18.4997 7.00008 17.9997 7.00008C17.4997 7.00008 15.7297 6.20008 15.1997 4.62008Z",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.9965 11H16.0054",
    stroke: "#0C80F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.9955 11H12.0045",
    stroke: "#0C80F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.99451 11H8.00349",
    stroke: "#0C80F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageFavorite);
export default __webpack_public_path__ + "static/media/message-favorite.66b1b4ae54683a86ab649bcf5f8a824c.svg";
export { ForwardRef as ReactComponent };